import { projectPositionSummary } from "../kernel/projectors.js";
import {
  commitAtomUpsert,
  loadPositionForCommand,
} from "../kernel/board-engine.js";
import type { ExecutionContext } from "../runtime/context.js";
import type { Readable } from "node:stream";
import type {
  AtomListRequest,
  AtomShowRequest,
  AtomUpsertRequest,
} from "../cli/protocol.js";
import { CliError } from "../errors/index.js";

export async function handleAtomUpsert(
  context: ExecutionContext,
  request: AtomUpsertRequest,
  stdin: Readable,
) {
  const result = await commitAtomUpsert(context, request.s, {
    atomId: request.a,
    bodySpec: request.b,
    fromPositionRef: request.p,
    kind: request.k,
    status: request.st,
    stdin,
    tags: request.g,
    title: request.t,
  });

  return {
    atom: result.atom,
    board: result.board,
    parent: projectPositionSummary(result.parent),
    position: projectPositionSummary(result.position),
  };
}

export async function handleAtomList(
  context: ExecutionContext,
  request: AtomListRequest,
) {
  const { position } = await loadPositionForCommand(context, request.s, request.p);
  return {
    atoms: Object.values(position.stateSnapshot.atoms).sort((left, right) =>
      left.id.localeCompare(right.id),
    ),
    position: projectPositionSummary(position),
  };
}

export async function handleAtomShow(
  context: ExecutionContext,
  request: AtomShowRequest,
) {
  const { position } = await loadPositionForCommand(context, request.s, request.p);
  const atom = position.stateSnapshot.atoms[request.a];
  if (atom === undefined) {
    throw new CliError("ATOM_NOT_FOUND", `Atom "${request.a}" was not found`);
  }
  return {
    atom,
    position: projectPositionSummary(position),
  };
}
